import { DevFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';

export default function isInverseModelDashboardEnabled(
  context: IAuthorizationContext,
): boolean {
  return context.featureChecker.devFeatureEnabled(DevFeatures.Experimental);
}
